// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { collection, doc, getDoc, getFirestore } from "firebase/firestore";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import React, { useEffect, useState } from "react";
import "firebase/compat/auth";
import { getAuth } from "firebase/auth";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { useDocumentData } from "react-firebase-hooks/firestore";
import { EVENT_TYPES, useEvents, EventsByType } from "../../firebase/realtime/Events";
import { Event } from "../../firebase/realtime/types";

const defaultData: [EventsByType, (event: Event) => void] = [
  Object.fromEntries(Object.values(EVENT_TYPES).map((eventType) => [eventType, []])),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  (e: Event) => {}
];

export const EventsContext = React.createContext(defaultData);

export const EventsProvider = ({courseId, children}) => {
  const auth = getAuth();
  const user = auth.currentUser;

  const [eventsByType, removeEvent] = useEvents(user?.uid, courseId)

  return (
    <EventsContext.Provider
      value={[eventsByType, removeEvent]}
    >
      {children}
    </EventsContext.Provider>
  );
};
